/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".prev[_ngcontent-%COMP%]{font-size:20px;color:#ff9d9dde;height:30px}.answer[_ngcontent-%COMP%]{width:100%;text-align:center;background:0 0;border:none}.incorrect[_ngcontent-%COMP%]{text-decoration:line-through}"];
export { styles as styles };
